import { ICommand, Topics } from '@zaplify/common';
import { ProspectDataDto, ProspectDto } from '../prospects';

export class UpdateProspectDataCommand extends ICommand<ProspectDto> {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly prospectId: string, readonly userId: string, readonly prospectData: Partial<ProspectDataDto>) {
        super();
    }
}
